<template>
    <div>
        <div id="aple"></div>
        <div id="popup">
            <div class="image-container" :style="style"></div>
            <div class="content">
                <div class="flex">
                    <div class="text-container" v-html="popup_data.text"></div>
                    <div class="button-container">
                        <a class="button" :href="popup_data.button_url" target="_blank" >{{ popup_data.button_name }}</a>
                    </div>
                </div>
            </div>
            <span id="popup-close"><svg xmlns="http://www.w3.org/2000/svg" width="36.562" height="36.563" viewBox="0 0 36.562 36.563">
                <g data-name="Group 8" transform="translate(-158.552 -554.052)">
                    <rect data-name="Rectangle 11" width="47.504" height="4.203" transform="translate(158.552 587.643) rotate(-45)" fill="#fff"/>
                    <rect data-name="Rectangle 17" width="47.504" height="4.203" transform="translate(192.143 590.615) rotate(-135)" fill="#fff"/>
                </g>
            </svg></span>
        </div>
    </div>
</template>

<script>
    export default
    {
        name: 'Popup',
        data() {
            return {
                style: {
                    backgroundImage: 'none'
                }
            }
        },
        props: {
            popup_data: {
                type: Object,
                required: false
            }
        },
        methods: {
            showPopup() {
                document.getElementsByTagName('body')[0].classList.add('popap-showed');
            },
            hidePopup() {
                document.cookie = "popup_closed=true; expires=0; path=/";
                document.getElementsByTagName('body')[0].classList.remove('popap-showed');
            }
        },
        created() {
            let vm = this;
            /*var preg = /(^|;)[\s]*popup_closed=([^;]+)/i;
            var popup_closed = document.cookie.match(preg);
*/
            if (vm.popup_data.image_url != null) {
                setTimeout(function() {
                    let img = new Image();
                    img.src = vm.popup_data.image_url;
                    img.onload = function() {
                        vm.style.backgroundImage = 'url(\'' + vm.popup_data.image_url + '\')';
                        vm.showPopup();
                    }
                }, 2000)
            } else {
                vm.showPopup();
            }
        },
        mounted(){
            let vm = this;
            document.getElementById('popup-close').addEventListener('click', function(){
                vm.hidePopup();
            });
        }
    }
</script>

<style lang="scss" scoped>

    #aple {
        pointer-events: none;
        transition: opacity 0.7s;
        opacity: 0;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 1;
        background-color: rgba(0,0,0, 0.4);
    }

    #popup {
        /* transition: transform 0.8s ease 0.3s; */
        transition: opacity 0.8s;
        background-color: #fff;
        position: fixed;
        opacity: 0;
        top: 50vh;
        flex-direction: column;
        width: 800px;
        left: 50vw;
        display: flex;
        max-width: 90vw;
        padding: 0;
        transform: translate(-50%,-250%);
        z-index: 2;
        height: 87vh;

        .content {
            font-family: 'Lato', sans-serif;
            font-size: 16px;
            color: #464646;
            box-sizing: border-box;
            width: 100%;
            padding: 40px 50px;
            flex-grow: 1;
        }

        .image-container {
            background-position: center;
            background-size: cover;
            flex-grow: 10;
            width: 100%;
        }

        #popup-close {
            position: absolute;
            padding: 18px;
            right: 0;
            top: 0;
            cursor: pointer;
        }

        .button {
            color: #fff;
            background-color: #000;
            line-height: 3em;
            text-decoration: none;
            font-size: 16px;
            text-align: center;
            padding: 0 2em;
            display: inline-block;
            margin: 1em 0;
            text-transform: uppercase;
        }

        svg {
            height: 18px;
            width: 18px;
            border: 8px solid #000;
            background-color: #000;
        }
    }

    @media screen and (min-width: 768px) {
        #popup {
            flex-direction: row;
            height: 500px;

            svg {
                border: 0 none;
                background-color: transparent;

                * {
                    fill: #000;
                }
            }

            .image-container,
            .content {
                width: 50%;
                padding: 50px;
            }

            .flex {
                display: flex;
                flex-direction: column;
                height: 100%;

                .text-container {
                    flex-grow: 50;
                }

                .button-container {
                    flex-grow: 1;
                }
            }
        }
    }

    .popap-showed {
        #popup {
            transform: translate(-50%,-50%);
            opacity: 1;
        }

        #aple {
            pointer-events: auto;
            opacity: 1;
        }
    }

</style>